import { SalePageSaleStatus } from '@/api/types';
import { Button } from '@/components';

type EndedSaleStatus = Extract<
  SalePageSaleStatus,
  'ENDED' | 'STOPPED' | 'SOLD_OUT'
>;

const statusLabels: Record<EndedSaleStatus, string> = {
  ENDED: '판매 종료',
  STOPPED: '판매 중지',
  SOLD_OUT: '품절',
};

interface EndedCTAProps {
  status: EndedSaleStatus;
}

export const EndedCTA = ({ status }: EndedCTAProps) => {
  return (
    <Button size="large" variant="solidTertiary" fullWidth disabled>
      {statusLabels[status]}
    </Button>
  );
};
